// Central dayjs configuration. Imports the plugins our codebase actually uses,
// then re-exports the configured dayjs so callers only need a single import path.
//
// Plugins registered:
// - customParseFormat: enables dayjs(value, "MM/DD/YYYY", true) strict parsing
// - utc: enables dayjs.utc(value)
//
// If new code needs additional plugins (relativeTime, duration, isBetween, etc.),
// register them here rather than per-file so the registration order stays consistent.

import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import utc from 'dayjs/plugin/utc';

dayjs.extend(customParseFormat);
dayjs.extend(utc);

export default dayjs;
